import React, { useEffect, useState, useCallback } from 'react'
import ThemeToggler from './ThemeToggler';
import { motion } from "framer-motion";
import '../css/Home.scss';
import laptop from "../Images/laptop.png";
import code from "../Images/codingLogo.png" 
const names = [
  'Debugger', 'Developer', 'Designer'
]
const Home = () => {
  const [newName, setnewName] = useState("Designer");
  const shuffle = useCallback(() => {
    const index = Math.floor(Math.random() * names.length);
    setnewName(names[index]);
  }, []);
  useEffect(() => {
    const intervalID = setInterval(shuffle, 2000);
    return () => clearInterval(intervalID);
  }, [shuffle])
  const motionStyle = {
    initial: {
      x: -100,
      opacity: 0,
    },
    whileInView: {
      opacity: 1,
      x: 0,
    },
    whileHover: {
      y: 5,
    }
  }
  const motionAnim = {
    initial: {
      y: -100,
      opacity: 0,
      overflow: 'hidden',
    },
    animate: {
      opacity: 1,
      y: 0,
    },
  }

  return (
    <>
      <div className='home'>
        <div className="textDiv">
          <motion.span initial={{opacity:0,x:-100,overflow:'hidden'}} whileInView={{opacity:1,x:0}} >Hi i'm a {newName}</motion.span>
          <ul>
            <li><a target={'_blank'} rel="noreferrer" href="https://www.instagram.com/thenightowlprogrammer"><motion.i {...motionStyle} className="fa-brands fa-instagram fa-3x"></motion.i></a></li>
            <li><a target={'_blank'} rel="noreferrer" href="https://github.com/asadansari8840"> <motion.i {...motionStyle} className="fa-brands fa-github fa-3x"></motion.i></a></li>
            <li><a target={'_blank'} rel="noreferrer" href="https://youtube.com/channel/UCELN5q4wntPjgLkMdOHNBYg"><motion.i {...motionStyle} className="fa-brands fa-youtube fa-3x"></motion.i></a></li>
            <li><a target={'_blank'} rel="noreferrer" href="#"><motion.i {...motionStyle} className="fa-brands fa-facebook fa-3x"></motion.i></a></li>
          </ul>
          {/* <button> */}
          <a target='_blank' href="https://mail.google.com/mail/u/0/?fs=1&to=thenightowlprogrammer@gmail.com&tf=cm"><button>Let's Chat</button></a>
        </div>

        <div className="imageDiv">
          <motion.img {...motionAnim} transition={{delay:1.5}} src={laptop} alt="Laptop Img"></motion.img>
          <motion.img className='codeLogo' {...motionAnim} transition={{delay:2.5}} src={code} alt="Code Img"></motion.img>
          <ThemeToggler />
        </div>
      </div>
      <hr className="style-one"></hr>
    </>
  )
}

export default Home